enum ModalState {
    OPEN,
    CLOSE,
    KEEP_OPEN,
    KEEP_CLOSED
};

export default ModalState;